import React, { useState } from "react";
import "vidstack/styles/defaults.css";
// import 'vidstack/styles/community-skin/video.css';
import "./MediaPlayer.css";
import "../VideoGuides.js";

import {
  MediaCommunitySkin,
  MediaOutlet,
  MediaPlayer,
  MediaPoster,
} from "@vidstack/react";

const MediaPlayers = ({ data }) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const handlePlay = (index) => {
    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      const currentVideo = document.getElementById(
        `video-${currentVideoIndex}`
      );
      if (currentVideo) {
        currentVideo.pause();
      }
    }

    setCurrentVideoIndex(index);
  };

  const handleEnded = () => {
    setCurrentVideoIndex(null);
  };

  return (
    <div className="video-grid-container">
      {data?.map((item, index) => (
        <div>
          <video
            className={`player ${
              currentVideoIndex === index ? "playing" : "paused"
            }`}
            key={index}
            id={`video-${index}`}
            width="350"
            height="300"
            controls
          >
            <source src={item.presigned_url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* <MediaPlayer
                        className={`player ${
                            currentVideoIndex === index ? 'playing' : 'paused'
                        }`}
                        key={index}
                        id={`video-${index}`}
                        src={item.presigned_url}
                        // poster={item?.thumbnailUrl ?? null}
                        // thumbnails={item?.thumbnailUrl ?? null}
                        aspectRatio={16 / 13}
                        crossorigin=''
                        onPlay={() => handlePlay(index)}
                        onEnded={handleEnded}>
                        <MediaOutlet>
                            <MediaPoster alt='Girl walks into sprite gnomes around her friend on a campfire in danger!' />
                            <track
                                src='https://media-files.vidstack.io/sprite-fight/subs/english.vtt'
                                label='English'
                                srcLang='en-US'
                                kind='subtitles'
                                default
                            />
                            <track
                                src='https://media-files.vidstack.io/sprite-fight/chapters.vtt'
                                srcLang='en-US'
                                kind='chapters'
                                default
                            />
                        </MediaOutlet>
                        <MediaCommunitySkin />
                    </MediaPlayer> */}

          <div className="media-title-container">
            <h4>{item.name}</h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MediaPlayers;
